import { AccountFeature, Account } from '../common/types/Accounts';
import { useActiveAccount } from '.';
import { useCallback } from 'react';

export type GetIsAccountFeatureDisabled = (
  accountFeature: AccountFeature,
) => boolean;

const emptyFeatures: AccountFeature[] = [];

export function useEnabledAccountFeatures(): AccountFeature[] {
  const activeAccount = useActiveAccount();

  return [...new Set(activeAccount?.features || [])] as AccountFeature[];
}

export function getIsAccountFeatureDisabled(
  account: Account,
  accountFeature: AccountFeature,
) {
  const accountFeatures = account?.features || emptyFeatures;

  return !accountFeatures.includes(accountFeature);
}

export function useGetIsAccountFeatureDisabled(): GetIsAccountFeatureDisabled {
  const activeAccount = useActiveAccount();

  return useCallback(
    (accountFeature: AccountFeature): boolean =>
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      getIsAccountFeatureDisabled(activeAccount, accountFeature),
    [activeAccount],
  );
}

function useIsAccountFeatureDisabled(accountFeature: AccountFeature): boolean {
  return useGetIsAccountFeatureDisabled()(accountFeature);
}

export default useIsAccountFeatureDisabled;
